import { Injectable } from '@angular/core';
import { Order } from '@spartacus/order/root';
import { Observable } from 'rxjs';
import { CheckOrderAdapter } from './check-order.adapter';

@Injectable()
export class CheckOrderConnector {
  constructor(protected adapter: CheckOrderAdapter) {}

  getOrder(orderId: string): Observable<Order> {
    return this.adapter.getOrder(orderId);
  }

  checkOrder(orderId: string): Observable<boolean> {
    return this.adapter.checkOrder(orderId);
  }
}
